import React from 'react'
import styles from './pagination.module.scss'
import cn from 'classnames'

const PaginationButton = ({ value, isCurrentPage, onPageButtonClick }) => {
  return (
    <div
      className={cn(
        styles.paginationButton,
        isCurrentPage ? styles.currentButton : styles.defaultButton,
      )}
      onClick={() => {
        if (!isCurrentPage) onPageButtonClick(value)
      }}
    >
      {value}
    </div>
  )
}

export default function Pagination({
  setCurrentPage,
  currentPage,
  totalPages,
}) {
  const lastPage = currentPage + 3 < totalPages ? currentPage + 3 : totalPages
  const firstPage = 1

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  return (
    <div className={styles.pagination}>
      {currentPage !== 1 && (
        <>
          <div className={styles.prevButton} onClick={handlePrevPage}>
            <img src="/search/arrow-left-black.svg" alt="black left arrow" />
          </div>
        </>
      )}

      {new Array(lastPage - firstPage + 1).fill().map((_e, i) => (
        <PaginationButton
          key={i}
          onPageButtonClick={setCurrentPage}
          value={firstPage + i}
          isCurrentPage={firstPage + i === currentPage}
        />
      ))}

      {lastPage !== totalPages && (
        <>
          <div className={styles.nextButton} onClick={handleNextPage}>
            <img src="/search/arrow-right-black.svg" alt="black right arrow" />
          </div>
        </>
      )}
    </div>
  )
}
